export const TOAST_DEFAULT_DURATION = 5000;
export const TOAST_STATUS = {
    CANCELLED: 'cancelled',
    DISMISSED: 'dismissed',
    TIMEOUT: 'timeout',
};
